<style>
.layout.row {
  margin-bottom: 20px !important;
}
</style>
<template>
  <div id="pageTable">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex sm12 style="text-align:right">
          <h3 style="float:left">Клиники</h3>
          <v-btn color="blue" dark small fab @click="refresh()">
            <v-icon>refresh</v-icon>
          </v-btn>
        </v-flex>

        <v-flex lg12>
          <v-card>
            <v-layout style="padding-left: 25px; padding-right: 25px;" card color="white">
              <v-flex v-for="ds in detailedSearch" :key="ds.searchKey">
                <v-text-field flat prepend-icon="search" :placeholder="ds.placeholder" v-model="ds.text" hide-details
                  clearable class="hidden-sm-and-down"></v-text-field>
              </v-flex>
              <v-btn @click="detailedSearchClear" icon>
                <v-icon>clear_all</v-icon>
              </v-btn>
            </v-layout>

            <v-divider></v-divider>

            <v-card-text class="pa-0">
              <v-data-table :headers="headers" :search="search" :items="items" :rows-per-page-items="[10, 25, 50, 100]"
                class="elevation-1" item-key="id" no-results-text="Нет результатов" rows-per-page-text="На странице"
                v-model="selectedItems">
                <template slot="items" slot-scope="props">
                  <tr :class="props.item.isActive ? null : 'red lighten-4'">
                    <td>{{ props.item.id }}</td>
                    <td>{{ props.item.name }}</td>
                    <td>{{ props.item.address }}</td>
                    <td>{{ props.item.cityId }}</td>
                    <td>{{ props.item.cityName }}</td>
                    <td>{{ props.item.staffResponsible }}</td>
                    <td>{{ props.item.nameStaffResponsible }}</td>
                    <td>{{ props.item.dobd }}</td>
                    <td>
                      <v-btn depressed outline icon fab dark color="primary" small
                        @click="openEditingModal(props.item)">
                        <v-icon>edit</v-icon>
                      </v-btn>
                      <v-btn depressed outline icon fab dark color="pink" small @click="openRemovingModal(props.item)">
                        <v-icon>delete</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </template>
              </v-data-table>

              <!-- Редактирование -->
              <div slot="widget-content">
                <v-dialog v-model="popupEdit.isOpen" persistent max-width="500px">
                  <v-card>
                    <v-card-title>
                      <span class="headline" v-if="editedIndex !== -1">
                        Редактирование
                      </span>
                    </v-card-title>

                    <v-list three-line subheader>
                      <v-layout row>
                        <v-flex xs4>
                          <v-subheader>Название клиники</v-subheader>
                        </v-flex>
                        <v-flex xs8>
                          <v-text-field label="Название клиники" v-model.lazy="modalData.name"
                            :rules="[rules.required]"></v-text-field>
                        </v-flex>
                      </v-layout>

                      <v-layout row>
                        <v-flex xs4>
                          <v-subheader>Адрес</v-subheader>
                        </v-flex>
                        <v-flex xs8>
                          <v-text-field label="Адрес" v-model.lazy="modalData.address"
                            :rules="[rules.required]"></v-text-field>
                        </v-flex>
                      </v-layout>

                      <v-layout row>
                        <v-flex xs4>
                          <v-subheader>ID города</v-subheader>
                        </v-flex>
                        <v-flex xs8>
                          <v-text-field label="ID города" v-model.lazy="modalData.cityId"
                            :rules="[rules.required]"></v-text-field>
                        </v-flex>
                      </v-layout>

                      <v-layout row>
                        <v-flex xs4>
                          <v-subheader>Широта</v-subheader>
                        </v-flex>
                        <v-flex xs8>
                          <v-text-field label="Широта" v-model.lazy="modalData.latitude"
                            :rules="[rules.required]"></v-text-field>
                        </v-flex>
                      </v-layout>

                      <v-layout row>
                        <v-flex xs4>
                          <v-subheader>Долгота</v-subheader>
                        </v-flex>
                        <v-flex xs8>
                          <v-text-field label="Долгота" v-model.lazy="modalData.longitude"
                            :rules="[rules.required]"></v-text-field>
                        </v-flex>
                      </v-layout>

                      <v-layout row>
                        <v-flex xs4>
                          <v-subheader>ID Ответственного</v-subheader>
                        </v-flex>
                        <v-flex xs8>
                          <v-text-field label="Ответственный" v-model.lazy="modalData.staffResponsible"></v-text-field>
                        </v-flex>
                      </v-layout>

                      <v-layout row>
                        <v-flex xs4>
                          <v-subheader>Статус</v-subheader>
                        </v-flex>
                        <v-flex xs8>
                          <v-switch v-model="modalData.isActive" />
                        </v-flex>
                      </v-layout>

                      <div>
                        <v-btn depressed color="primary" @click="goMap(modalData)">Карта
                          <v-icon right dark>map</v-icon>
                        </v-btn>
                      </div>
                    </v-list>

                    <v-card-actions>
                      <v-btn flat @click="closeEditingModal()">Закрыть</v-btn>
                      <v-btn color="primary" dark flat @click.native="submit()">Сохранить</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </div>

              <!-- Удаление -->
              <div slot="widget-content">
                <v-dialog v-model="popupRemove.isOpen" persistent max-width="500px">
                  <v-card>
                    <v-card-title>
                      <span class="headline">Вы уверены что хотите удалить клинику?</span>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" flat @click.native="closeRemovingModal()">Отмена</v-btn>
                      <v-btn color="blue darken-1" flat @click.native="remove(modalData);">Да, уверен</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </div>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import Logging from '../../store/modules/logging';

export default {
  data() {
    return {
      modalData: {},
      oldModalData: {},
      editedIndex: {},
      rules: {
        required: value => !!value || 'Обязательное поле',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || 'Некорректный email';
        },
      },
      search: '',
      popupRemove: {
        isOpen: false
      },
      popupEdit: {
        isOpen: false,
        isEditing: false
      },
      detailedSearch: [
        {
          placeholder: 'ID',
          searchKey: 'id',
          text: ''
        },
        {
          placeholder: 'Название',
          searchKey: 'name',
          text: ''
        },
        {
          placeholder: 'Адрес',
          searchKey: 'address',
          text: ''
        },
        {
          placeholder: 'ID города',
          searchKey: 'cityId',
          text: ''
        },
        {
          placeholder: 'Город',
          searchKey: 'cityName',
          text: ''
        },
        {
          placeholder: 'Ответственный сотрудник',
          searchKey: 'nameStaffResponsible',
          text: ''
        },
        {
          placeholder: 'ID ответственного',
          searchKey: 'staffResponsible',
          text: ''
        }
      ],
      selectedItems: [],
      headers: [
        {
          text: 'ID',
          value: 'id'
        },
        {
          text: 'Название',
          value: 'name'
        },
        {
          text: 'Адрес',
          value: 'address'
        },
        {
          text: 'ID города',
          value: 'cityId'
        },
        {
          text: 'Город',
          value: 'cityName'
        },
        {
          text: 'ID ответственного',
          value: 'staffResponsible'
        },
        {
          text: 'Ответственный сотрудник',
          value: 'nameStaffResponsible'
        },
        {
          text: 'DOBD рейтинг',
          value: 'dobd'
        },
        {
          text: 'Действия',
          value: ''
        }
      ],
    };
  },

  computed: {
    items() {
      let clinicList = this.$store.getters['clinics/items'];

      this.detailedSearch.forEach(filter => {
        if (filter.text !== "" && filter.text !== null) {
          clinicList = clinicList.filter(
            clinic => String(clinic[filter.searchKey])
              .toLowerCase()
              .indexOf(filter.text.toLowerCase()) !== -1
          );
        }
      });

      return clinicList;
    },
  },

  mounted: function () {
    if (!this.items.length) this.refresh();
  },

  methods: {
    refresh() {
      this.$store.dispatch('clinics/loadItems');
    },

    openEditingModal(item) {
      this.popupEdit.isOpen = true;
      this.modalData = item;
      this.oldModalData = Object.assign({}, this.modalData);
      this.editedIndex = this.items.indexOf(item);
    },

    closeEditingModal() {
      Object.assign(this.items[this.editedIndex], this.oldModalData);
      this.popupEdit.isOpen = false;
    },

    loggingData(data, initial = '', changed = '', roles = {}) {
      let basicData = Logging.actions.getBasicBaseData();

      return {
        payload: {
          '203': `Пользователь: ${basicData.fullname ? basicData.fullname : 'ФИО не указано'}, ${basicData.email ? basicData.email : 'Email не указан'}; Клиника: ${data.data.name}; Адрес: ${data.data.address}`,
          '207': `Пользователь: ${basicData.fullname ? basicData.fullname : 'ФИО не указано'}, ${basicData.email ? basicData.email : 'Email не указан'}; Клиника: ${data.data.name}; Адрес: ${data.data.address}`,
          '211': `Пользователь: ${basicData.fullname ? basicData.fullname : 'ФИО не указано'}, ${basicData.email ? basicData.email : 'Email не указан'}; Клиника: ${data.data.name}; Что изменено: ${changed}`,
          '215': `Пользователь: ${basicData.fullname ? basicData.fullname : 'ФИО не указано'}, ${basicData.email ? basicData.email : 'Email не указан'}; Клиника: ${data.data.name}; Адрес: ${data.data.address}`,
        },
        comment: {
        }
      }
    },

    submit() {
      console.debug('Modal: ', this.oldModalData, this.modalData);
      this.$store.dispatch('clinics/save', { index: this.editedIndex, data: this.modalData })
        .then(async () => {
          console.debug(this.modalData);

          if (this.modalData.id == -1) {
            await Logging.actions.commitLogData('203', Logging.actions.getBasicBaseData().username, this.loggingData({ data: this.modalData }).payload['203']);
          } else {
            if (!this.modalData.isActive && this.oldModalData.isActive) {
              await Logging.actions.commitLogData('207', Logging.actions.getBasicBaseData().username, this.loggingData({ data: this.modalData }).payload['207']);
            }
          }

          if (this.modalData.isActive && !this.oldModalData.isActive) {
            await Logging.actions.commitLogData('215', Logging.actions.getBasicBaseData().username, this.loggingData({ data: this.modalData }).payload['215']);
          }

          // Удаление флага необходимости смены связи "accountId - staffId"
          delete this.modalData.staffIdChange;

          let changedModalData = Logging.actions.getChangedFields(this.oldModalData, this.modalData);
          if (this.modalData.id != -1 && changedModalData.length > 0) {
            await Logging.actions.commitLogData('211', Logging.actions.getBasicBaseData().username, this.loggingData({ data: this.modalData }, '', changedModalData).payload['211']);
          }

          this.popupEdit.isOpen = false;
        });
    },

    openRemovingModal(data) {
      this.popupRemove.isOpen = true;
      this.modalData = data;
    },

    closeRemovingModal() {
      this.popupRemove.isOpen = false;
    },

    remove(item) {
      this.$store.dispatch('clinics/remove', { item });
      this.closeRemovingModal();
    },

    goMap(item) {
      window.open(`https://yandex.ru/maps/?ll=&pt=${item.longitude}%2C${item.latitude}&z=15`, '_blank');
    },

    detailedSearchClear() {
      this.detailedSearch = this.detailedSearch.map(s => ({
        ...s,
        text: '',
      }));
    },
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/ui/Clinics.vue